import MachineLearning from './assets/Machine-Learning.png';
import CreatorEconomy from './assets/Creator-Economy.png';
import ConfidentialVoting from './assets/Confidential-Voting.png';
import ConfidentialPayment from "./assets/ConfidentialPayment.png";
import MachineLearningsS from "./assets/Machine-Learning-s.png";
import CreatorEconomyS from "./assets/Creator-Economy-s.png";
import ConfidentialVotingS from "./assets/Confidential-Voting-s.png";
import ConfidentialPaymentS from "./assets/ConfidentialPayment-s.png";
import { DocsLink } from "@src/constant/navLinks";

export const tabs = [
  {
    title: "Proof of Reserves",
    content:
      "Generate cryptographic Proof of Reserves for exchanges, stablecoin issuers, custodians, and asset managers. Enable transparent reserve verification while keeping sensitive operational data private.",
    cover: CreatorEconomy,
    coverS: CreatorEconomyS,
    link: "/por",
  },
  {
    title: "Confidential Financial Services",
    content:
      "Enable confidential payments, stablecoin transfers, and institutional settlement with zkTLS and FHE. Combine verifiable identity, compliance, and transaction privacy within a unified infrastructure layer.",
    cover: ConfidentialVoting,
    coverS: ConfidentialVotingS,
    link: `${DocsLink}fhe/use-cases/confidential-transfer/`,
  },
  {
    title: "Trusted Credit Infrastructure",
    content:
      "Turn verified off-chain identity, assets, income, and behavioral data into privacy-preserving on-chain credit. Enable trusted lending, institutional risk management, DeFi, and AI agents without revealing sensitive information.",
    cover: ConfidentialPayment,
    coverS: ConfidentialPaymentS,
    link: "https://app.primuslabs.xyz/home",
  },
  {
    title: "Trusted AI Data",
    content:
      "Verify AI-generated workflows, conversations, and execution records with cryptographic proof. Transform AI outputs into trusted digital assets for AI training, knowledge marketplaces, and autonomous applications.",
    cover: MachineLearning,
    coverS: MachineLearningsS,
    link: "https://github.com/primus-labs/skills",
  },
];
